import { render, staticRenderFns } from "./labelTypePage.vue?vue&type=template&id=1a0fa2aa&scoped=true"
import script from "./labelTypePage.vue?vue&type=script&lang=js"
export * from "./labelTypePage.vue?vue&type=script&lang=js"
import style0 from "./labelTypePage.vue?vue&type=style&index=0&id=1a0fa2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0fa2aa",
  null
  
)

export default component.exports